import React from "react";

// Styles
import "./styles.scss";

const NoInternet = () => {
  return (
    <div className="no-internet-root-container">
      <h1 className="no-internet-heading">No Internet</h1>
      <p className="no-internet-sub-heading">Connection Lost</p>
      <p className="no-internet-message">
        Please check your internet connection and try again.
      </p>
    </div>
  );
};

export default NoInternet;
